import { OrganizationMember } from '@prisma/client'
import { ReactNode, createContext, useContext } from 'react'
import { useConversations } from '../hooks/useConversations'

const useInternal = ({
  organizationMember,
}: {
  organizationMember: OrganizationMember
}) => {
  const { conversations, findByOrganizationMember, refresh, countRefresh } =
    useConversations({
      organizationMember,
    })

  return {
    conversations,
    findByOrganizationMember,
    refresh,
    countRefresh,
  }
}

type ChatContext = ReturnType<typeof useInternal>

const ChatContext = createContext<ChatContext>(undefined)

export const ChatProvider = ({
  children,
  organizationMember,
}: {
  children: ReactNode
  organizationMember: OrganizationMember
}) => {
  const value = useInternal({ organizationMember })

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>
}

export const useChatContext = (): ChatContext => {
  const context = useContext(ChatContext)

  if (context === undefined) {
    throw new Error('useChatContext must be used within a UserProvider')
  }

  return context
}
